export enum ListLayout {
  LAYOUT1 = 'list_layout1',
  LAYOUT2 = 'list_layout2',
  LAYOUT3 = 'list_layout3',
}
